/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskApprovalsList } from "../funcs/riskApprovalsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListRiskPolicyApprovalsResult } from "../models/components/listriskpolicyapprovalsresult.js";
import {
  ListRiskPolicyApprovalsRequest,
  ListRiskPolicyApprovalsSecurity,
  Status,
} from "../models/operations/listriskpolicyapprovals.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskListApprovalsQueryData = ListRiskPolicyApprovalsResult;

export function prefetchRiskListApprovals(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRiskPolicyApprovalsRequest | undefined,
  security?: ListRiskPolicyApprovalsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskListApprovalsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskListApprovalsQuery(
  client$: GramCore,
  request?: ListRiskPolicyApprovalsRequest | undefined,
  security?: ListRiskPolicyApprovalsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RiskListApprovalsQueryData>;
} {
  return {
    queryKey: queryKeyRiskListApprovals({
      status: request?.status,
      cursor: request?.cursor,
      limit: request?.limit,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskListApprovalsQueryFn(
      ctx,
    ): Promise<RiskListApprovalsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskApprovalsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskListApprovals(
  parameters: {
    status?: Status | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "approvals", "list", parameters];
}
